const IMAGE_BASE = '/company-assets/about/images/about';

export type AboutTeamMember = {
  name: string;
  role: string;
  imageSrc: string;
};

export type AboutNewsItem = {
  href: string;
  imageSrc: string;
  label: string;
};

export const ABOUT_HERO = {
  brand: 'KudosWall',
  title: 'Meet the KudosWall Family',
  description:
    'Here are the friendly faces who make building your resumes and portfolios easier!',
} as const;

export const ABOUT_MISSION = {
  heading: 'our mission',
  quote:
    'Here at KudosWall, we know that you’re multidimensional. That’s why we want to help you showcase your achievements in a holistic way. Beautiful resumes being built by an easy-to-use and effortless tool should be at the forefront of sharing your experiences...and that’s why we’re here!',
} as const;

export const ABOUT_TEAM: AboutTeamMember[] = [
  {
    name: 'Jag Vootkur',
    role: 'Factotum - Co-Founder&CEO',
    imageSrc: `${IMAGE_BASE}/jag.jpg`,
  },
  {
    name: 'Nikhil Vootkur',
    role: 'Thinker Upper - Co-Founder&Designer',
    imageSrc: `${IMAGE_BASE}/nik.jpg`,
  },
  {
    name: 'Akhil KA',
    role: 'Tech Ninja/Engineering Lead',
    imageSrc: `${IMAGE_BASE}/akhil.jpg`,
  },
  {
    name: 'Natalie Shaw',
    role: 'Marketing Wiz/Marketing & Communications',
    imageSrc: `${IMAGE_BASE}/Natalie.jpg`,
  },
  {
    name: 'Emily Bollinger',
    role: 'Communications',
    imageSrc: `${IMAGE_BASE}/emily.jpg`,
  },
  {
    name: 'Jaison James',
    role: 'Developer',
    imageSrc: `${IMAGE_BASE}/jaison.jpg`,
  },
  {
    name: 'Sajith K',
    role: 'On the Go/Developer',
    imageSrc: `${IMAGE_BASE}/sajith.jpg`,
  },
  {
    name: 'Shilpa',
    role: 'Communications',
    imageSrc: `${IMAGE_BASE}/silpa.jpg`,
  },
  {
    name: 'Sreedevi R',
    role: 'Tester',
    imageSrc: `${IMAGE_BASE}/sreedevi.jpg`,
  },
];

export const ABOUT_NEWS: AboutNewsItem[] = [
  {
    href: 'https://www.businessnhmagazine.com/article/kudoswall-seeks-to-be-linkedin-for-kids',
    imageSrc: `${IMAGE_BASE}/BNH_logo_med.png`,
    label: 'Business NH Magazine',
  },
  {
    href: 'http://www.unionleader.com/article/20161009/NEWS19/161009355/1007',
    imageSrc: `${IMAGE_BASE}/NH-UnionLeader.png`,
    label: 'New Hampshire Union Leader',
  },
  {
    href: 'http://livefreeandstart.com/innovators/jag-vootkur-kudoswall-update/',
    imageSrc: `${IMAGE_BASE}/Innovator_of_the_Week_Badge.jpg`,
    label: 'Innovator of the Week',
  },
  {
    href: 'https://nhhtc.org/awards-at-2016-techout/',
    imageSrc: `${IMAGE_BASE}/TO_3rd_Place_We_Badge.jpg`,
    label: 'TechOut award',
  },
];
